import { Identifier } from "react-admin";
import { FinlandCommunicationAssetLevelEnum, FinlandCommunicationServiceOperatorEnum } from "shared/enums/globalEnums";
import { AssociationCreatePayload, GroupSiteAssociationFormValues, NewSitesMetrics, SiteMetricPayload } from "../types";

export const buildMetricsPayload = (newSites: NewSitesMetrics, asset_id: Identifier): SiteMetricPayload[] => {
  if (!newSites || Object.keys(newSites).length === 0) return [];
  return Object.entries(newSites).flatMap(([site_id, metrics]) => {
    return Object.entries(metrics).reduce<SiteMetricPayload[]>((acc, [metric, { range_min, range_max, direction }]) => {
      if (typeof range_min === "string" || typeof range_max === "string") return acc;
      acc.push({
        service_operator: FinlandCommunicationServiceOperatorEnum.TSO,
        asset_level: FinlandCommunicationAssetLevelEnum.PROVIDING_ENTITY,
        asset_id: +asset_id,
        direction,
        metric,
        site_id: +site_id,
        range_min,
        range_max,
      });
      return acc;
    }, []);
  });
};

export const parseErrorMessage = (error: any) => {
  if (error.body && Array.isArray(error.body) && error.body.length && error.body[0]?.message) {
    return error.body[0].message;
  }
  return "An unknown error occurred";
};

export const getErrorMessageCause = (e: unknown): string => (e instanceof Error ? e.message : String(e));

export const normalizeAssociationValues = (values: GroupSiteAssociationFormValues): AssociationCreatePayload => {
  const associationPayload = { ...values };
  if (associationPayload.groupType) {
    delete associationPayload.groupType;
  }
  return associationPayload;
};

export const prepareAssoDataForSummary = (data: GroupSiteAssociationFormValues): GroupSiteAssociationFormValues => {
  const associationPayload = { ...data };
  if (associationPayload.group_id) {
    associationPayload.group_ids = [associationPayload.group_id];
    delete associationPayload.group_id;
  }
  return associationPayload;
};

export function formatMetricLabel(key: string): string {
  return key.replace(/_/g, " ");
}
